import { TaskList } from "../../component-project-detail";

export type DesignInfoInputDialogState = {
  task: TaskList;
  designInfo: string;
  isShow: boolean;
  isEdited: boolean;
  reqTskSlctdFlg: string;
  formValidation: boolean;
};
export type PageNewState =
  | DesignInfoInputDialogState
  | ((prevState: DesignInfoInputDialogState) => DesignInfoInputDialogState);
